export function XeroSupportFindPaymentsCtrl ($scope, domainParserApi, payments) {

  $scope.payments = payments ? payments : {};

  // IE specific properties to enable flipper modal compatibility
  $scope.IE = domainParserApi.isInternetExplorer();
  $scope.flipped = false;

  $scope.tableSettings = {
    columns: [
      {
        field : 'PaymentID',
        header: {
          text: 'ID'
        }
      },
      {
        field : 'Date',
        header: {
          text: 'Date'
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PAYMENTS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowDoubleClick = function (payment) {
    $scope.flipped = !$scope.flipped;
    $scope.payment = payment.row;
    $('.modal-content').addClass('flip');
  };

  $scope.back = function () {
    $('.modal-content').removeClass('flip');
  };

}